if (!customElements.get("b-secondary-menu")) {
  customElements.define(
    "b-secondary-menu",
    class BSecondaryMenu extends HTMLElement {
      connectedCallback() {
        this.handleSectionLoad = () => requestAnimationFrame(() => this.mountMobileMenu());
        document.addEventListener("shopify:section:load", this.handleSectionLoad);

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", this.handleSectionLoad, { once: true });
        } else {
          this.handleSectionLoad();
        }
      }

      disconnectedCallback() {
        document.removeEventListener("shopify:section:load", this.handleSectionLoad);
        this.removeMobileMenu();
      }

      mountMobileMenu() {
        const drawerMenu = document.querySelector("#MenuDrawer .drawer__menu[data-parent]");
        const template = this.querySelector("template[data-secondary-menu-mobile]");

        if (!drawerMenu || !template) return;

        this.removeMobileMenu();

        const fragment = template.content.cloneNode(true);
        fragment.querySelectorAll("[data-secondary-menu-item]").forEach((item) => {
          item.dataset.secondaryMenuOwner = this.dataset.sectionId;
        });
        drawerMenu.append(fragment);

        const drawer = drawerMenu.closest("menu-drawer");
        if (drawer) drawer._menuItems = null;
      }

      removeMobileMenu() {
        document.querySelectorAll("[data-secondary-menu-owner]").forEach((item) => {
          if (item.dataset.secondaryMenuOwner === this.dataset.sectionId) item.remove();
        });
      }
    }
  );
}
